import {Inject, Injectable} from '@angular/core';
import {WebsocketService} from './websocket';
import {from, Observable, ReplaySubject} from 'rxjs';
import {first, throttleTime} from 'rxjs/operators';
import {isNull, isUndefined} from 'util';
import {NotificationService} from './notification.service';
import {HttpClient} from '@angular/common/http';
import {AndroidInterface, Chat, Contact, IMessengerConnector, Message} from '../types/all.type';
import {DatePipe} from '@angular/common';
import {environment} from '../../environments/environment';
import {isMobile, log} from '../functions';
import {NotifierWrapService} from './notifier-wrap.service';
import {document} from 'ngx-bootstrap/utils';
import {InterfaceService} from './interface.service';
import {DcService} from './dc.service';

declare let Android: AndroidInterface;

@Injectable({
  providedIn: 'root'
})
export class AllService {
  public environment = environment;
  public arChat: Chat[] = [];
  public arContacts: Contact[] = [];
  saveLocalChats$: ReplaySubject<void> = new ReplaySubject();
  // XMPP
  public addLastMessage$: ReplaySubject<{message: Message, service_type: string}> = new ReplaySubject();
  ///
  public token: string;
  public setService$: ReplaySubject<any> = new ReplaySubject();
  public serviceType: 'vk' | 'telegram' | 'whatsapp' | 'skype' | 'all' | 'fellowdesk' = 'fellowdesk';
  public savedDraft = {};
  public arDetectChangesLog: any = {
    MessageComponent: 0,
    MessageAttachmentsComponent: 0,
    MessagesScrollComponent: 0,
    ChatListComponent: 0,
    OnlineSliderComponent: 0,
    ChatShowComponent: 0
  };
  public test: any;
  public textAreaPosition: number | false;
  public newMessage$: ReplaySubject<Message> = new ReplaySubject();
  public loadedChats$: ReplaySubject<void> = new ReplaySubject();

  public reloadChat$: ReplaySubject<void> = new ReplaySubject();
  public login$: ReplaySubject<IMessengerConnector> = new ReplaySubject();
  public logout$: ReplaySubject<void> = new ReplaySubject();
  public isTouchDevice = navigator.maxTouchPoints || typeof document.documentElement?.ontouchstart !== 'undefined';
  public _vkDisconnect = false;
  public lastChatId: any = false;
  public _openChatId: any;
  demoToken = 'u7l5u6g2nnfcro07ivybnppjlt9bwmdts';
  public arPinnedMessages: Message[];


  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    public notifierWrapService: NotifierWrapService,
    private datePipe: DatePipe,
    private http: HttpClient,
    @Inject('instanceAll') public wsService: WebsocketService,
    private notificationService: NotificationService,
    @Inject('instanceWhatsapp') public wsServiceWhatsapp: WebsocketService,
  ) {
    this.login$.subscribe(() => {
      this.notifierWrapService.playAudio('startup2', false, 0.5);
    });
    if (environment.useProxy) {
      // @ts-ignore
      window['isProxy'] = true;
    }
    this.savedDraft = JSON.parse(localStorage.getItem('draft_message')) || {};
    this.setToken();

    this.wsService.status.subscribe((status) => {
      // alert(status + ' - ' + this.wsService.isConnected + ' - ' + this.wsService.disconnect + ' - ' + this.wsService.type);
      // log('all: ', this.wsService)
      if (!this.isAndroid()) {
        if (!status) {
          this.notificationService.push({
            title: 'Соединение с сервером разорвано',
            text: 'Идет переподключение, проверьте интернет.',
            clickUrl: '',
            path: 'error',
            avatar: '',
            urgency: 'critical',
            subtitle: 'ERROR',
            id: 0
          });
        } else if (status && this.wsService.disconnectedCount > 0) {
          this.notificationService.push({
            title: 'Соединение восстановлено',
            text: 'Вы могли пропустить сообщения полученные во время отсутствия соединения.',
            clickUrl: '',
            path: 'error',
            avatar: '',
            urgency: 'critical',
            subtitle: 'OK',
            id: 0
          });
        }
      }
    });
    this.arChat = this.getVarLocal('chats', []);
    this.arContacts = this.getVarLocal('contacts', []);
    this.setService$.subscribe((type) => {
      delete this._openChatId;
      this.serviceType = type;
    });
    if (!this.doesSupportEmoji()) {
      this.interfaceService.supportEmoji = false;
    }

    this.saveLocalChats$.pipe(throttleTime(10000)).subscribe(() => {
      this.setVarLocal('chats', this.arChat);
    });
  }


  doesSupportEmoji(): boolean {
    if (!document.createElement('canvas').getContext) { return; }
    const context = document.createElement('canvas').getContext('2d');
    if (typeof context.fillText !== 'function') { return; }
    const smile = String.fromCharCode(55357) + String.fromCharCode(56835);

    context.textBaseline = 'top';
    context.font = '32px Arial';
    context.fillText(smile, 0, 0);
    return context.getImageData(16, 16, 1, 1).data[0] !== 0;
  }

  get vkDisconnect(): boolean {
    return this._vkDisconnect;
  }

  set vkDisconnect(val) {
    this.dcService.detectChangesConnect$.next();
    this._vkDisconnect = val;
  }

  isFocused(): boolean {
    return document.hasFocus();
  }

  isMediaFullScreen(): boolean {
    return document.body.classList.contains('lg-on');
  }
  generateToken() {
    return Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
  }
  setToken(): void {
    this.token = localStorage.getItem('token');
    if (isNull(this.token) || this.token === 'null') {
      const rand = this.generateToken();
      log('Authorization token');

      localStorage.setItem('token', rand);
      this.token = rand;
      /*this.wsService.token = rand;
      this.wsService.initConfig();*/
      /* this.oldToken = this.token;
            this.token = this.demoToken;
            localStorage.setItem('token', this.token);
            localStorage.setItem('auth_telegram', new Date().getTime().toString());*/
    }
  }

  getCookie(name: string): string | undefined {
    const matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  setCookie(name: string, value: string | number, props: any): void {
    props = props || {};
    let exp = props.expires;
    if (typeof exp === 'number' && exp) {
      const d = new Date();
      d.setTime(d.getTime() + exp * 1000);
      exp = props.expires = d;
    }
    if (exp && exp.toUTCString) {
      props.expires = exp.toUTCString();
    }
    value = encodeURIComponent(value);
    let updatedCookie = name + '=' + value;
    for (const propName in props) {
      updatedCookie += '; ' + propName;
      const propValue = props[propName];
      if (propValue !== true) {
        updatedCookie += '=' + propValue;
      }
    }
    document.cookie = updatedCookie;
  }

  clearDraft(id: string | number): void {
    delete this.savedDraft[id];
    this.saveDraft();
  }

  saveDraft(): void {
    try {
      localStorage.setItem('draft_message', JSON.stringify(this.savedDraft));
    } catch (e) {
      // console.error('setVarLocal error', e, this.savedDraft);
      log('setVarLocal error', e, this.savedDraft);
    }
  }

  fallbackCopyTextToClipboard(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      console.log('Copy success', text)
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  copyTextToClipboard(text: string): void {
    try {
      Android.copyTextToClipboard(text);
    } catch (e) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        () => {
          log('Async: Copying to clipboard was successful!');
        },
        (err) => {
          console.error('Async: Could not copy text: ', err);
        }
      );
    }
  }
  effectMouseMove(e: any, className = 'effectMouse'): void {
    if (isMobile()) { return; }
    const el = e?.path?.find((v) => v.className?.length > 0 && v.className?.includes(className));
    if (el) {
      const box = el.getBoundingClientRect();
      const x = e.pageX - box.left;
      const y = e.pageY - box.top;
      el.style.setProperty('--x', `${x}px`);
      el.style.setProperty('--y', `${y}px`);
    }
  }

  Utf8ArrayToStr(array) {
    let out, i, c;
    let char2, char3;

    out = '';
    const len = array.length;
    i = 0;
    while (i < len) {
      c = array[i++];
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += String.fromCharCode(c);
          break;
        case 12:
        case 13:
          // 110x xxxx   10xx xxxx
          char2 = array[i++];
          out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = array[i++];
          char3 = array[i++];
          out += String.fromCharCode(((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0));
          break;
      }
    }

    return out;
  }

  crossDomainRequest(url: string, method = 'GET') {
    // log('crossDomainRequest: ' + url);
    return new Observable((observer) => {
      try {
        // Android
        const run = Android.httpQueryPromise(url, method);

        run.then = (callback) => {
          const name = 'callback_' + Math.floor(Math.random() * 100000);
          window[name] = callback;
          // @ts-ignore
          return run.thenJS(name);
        };

        run.then((a: any) => {
          observer.next(JSON.parse(a.toString()));
          observer.complete();
        });
      } catch (e) {
        // Electron
        try {
          const electron = window?.require('electron');
          const net = electron?.remote?.net;
          const request = net.request({
            method,
            url
          });

          request.end();
          request.on('response', (response) => {
            response.on('data', (data) => {
              if (typeof data === 'object') {
                const convert = this.Utf8ArrayToStr(data);
                if (convert?.length > 0) {
                  data = convert;
                }
              }

              if (typeof data === 'string') {
                data = JSON.parse(data);
              }
              // log('HTTP_ELECTRON', url, method, data)
              observer.next(data);
              observer.complete();
            });

            response.on('error', (error) => {
              try {
                // log(`ERROR: ${JSON.stringify(error)}`)
              } catch (e) {}
              // log(`ERROR:`, error);
              observer.error(error);
              observer.complete();
            });
          });
        } catch (e) {
          this.http
            .get(
              `https://messenger.soft-angel.ru/get.php?url=` +
                encodeURIComponent(url) +
                '&random_id=' +
                Math.floor(Math.random() * 99999999)
            )
            .subscribe(
              (data: any) => {
                if (typeof data === 'string') {
                  data = JSON.parse(data);
                }
                observer.next(data);
                observer.complete();
              },
              (error) => {
                observer.error(error);
                observer.complete();
              }
            );
        }
      }
    }).pipe(first()); // , tag("crossDomainRequest")
  }

  clearReplyDraft(id: string | number) {
    delete this.savedDraft['reply_' + id];
    this.saveDraft();
  }

  saveReplyDraft(id: string | number, message: Message) {
    this.savedDraft['reply_' + id] = message;
    this.saveDraft();
  }

  restoreReplyDraft(id: string | number): Message | false {
    return this.savedDraft['reply_' + id] || false;
  }

  set isCloseChat(val: boolean) {
    this.interfaceService.isCloseChat$.next(val);
    if (val) {
      delete this._openChatId;
    }
    // this.closeChat$.next(val);
  }

  get isCloseChat() {
    return this.interfaceService.isCloseChat$.value;
  }

  isAndroid() {
    return typeof Android !== 'undefined';
  }

  isElectron() {
    try {
      window?.require('electron');
      return true;
    } catch (e) {
      return false;
    }
  }

  fetchSimilarHeaders(callback, url: string) {
    const request = new XMLHttpRequest();
    request.onreadystatechange = () => {
      if (request.readyState === XMLHttpRequest.DONE) {
        if (callback && typeof callback === 'function') {
          callback(request.getAllResponseHeaders());
        }
      }
    };
    request.open('HEAD', url, true);
    request.send(null);
  }

  openLocalFile(downloadLocalUri: string, downloadMimeType: string): void {
    try {
      Android.openLocalFile(downloadLocalUri, downloadMimeType);
    } catch (e) {
      try {
        const electron = window?.require('electron');
        electron.shell.openPath(downloadLocalUri);
        electron.ipcRenderer.send('download', downloadLocalUri);
      } catch (e) {}
    }
  }

  downloadFile(downloadUrl: string, attachment: any = {}, check = true): Observable<any> {
    this.fetchSimilarHeaders((res) => {
      log('fetchSimilarHeaders');
      // log(res);
    }, downloadUrl);
    return new Observable((observer) => {
      if (this.isAndroid()) {
        // Android
        const run = Android.downloadFile(
          downloadUrl?.replace('&download=true', ''),
          attachment.file_name || this.basename(downloadUrl, '')
        );
        run.then = (callback) => {
          const name = 'callback_' + Math.floor(Math.random() * 100000);
          window[name] = callback;
          // @ts-ignore
          return run.thenJS(name);
        };

        run.then((a: number) => {
          attachment.downloadId = a;
          const intr = setInterval(() => {
            attachment.downloadInfo = JSON.parse(Android.statusDownloadFile(a));
            if (attachment.downloadInfo.status === 'Download complete!') {
              clearInterval(intr);
              observer.complete();
            }
            observer.next(attachment.downloadInfo);
          }, 300);
        });
      } else {
        try {
          const electron = window?.require('electron');
          const hashCode = (s) => {
            return s.split('').reduce((a, b) => {
              a = (a << 5) - a + b.charCodeAt(0);
              return a & a;
            }, 0);
          };
          attachment.hashCode = hashCode(downloadUrl);
          electron.ipcRenderer.on('download progress ' + attachment.hashCode, (event, progress) => {
            const cleanProgressInPercentages = Math.floor(progress.percent * 100); // Without decimal point
            const progressInPercentages = progress.percent * 100; // With decimal point and a bunch of numbers
            attachment.downloadInfo = {
              status: 'Download',
              progress: progressInPercentages,
              bytes_downloaded: progress.transferredBytes,
              bytes_total: progress.totalBytes
            };
            observer.next(attachment.downloadInfo);
            if (cleanProgressInPercentages === 100) {
            }
          });
          electron.ipcRenderer.on('download complete ' + attachment.hashCode, (event, file) => {
            attachment.downloadInfo.local_uri = file;
            attachment.downloadInfo.status = 'Completed';
            this.openLocalFile(file, '');
            observer.next(attachment.downloadInfo);
            observer.complete();
          });
          electron.ipcRenderer.send('download', {
            url: downloadUrl,
            hash: attachment.hashCode,
            properties: {} // {directory: "Directory is here"}
          });
        } catch (e) {
          if (check) {
            this.fetchSimilarHeaders((res) => {
              window.open(downloadUrl, '_blank');
            }, downloadUrl);
          }else{
            window.open(downloadUrl, '_blank');
          }

          observer.next({});
          observer.complete();
        }
      }
    }).pipe(); // tag("downloadFile")
  }

  downloadURI(uri, name) {
    const link = document.createElement('a');
    link.download = name;
    link.href = uri;
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  basename(path: string, suffix): string {
    if (!path) {
      return '';
    }
    const p = path?.split(/[\/\\]/);
    const name = p[p?.length - 1];
    return ('string' !== typeof suffix ? name : name.replace(new RegExp(suffix.replace('.', '\\.') + '$'), '')).split(
      '?'
    )[0] || '';
  }

  openDevTools() {
    const electron = window?.require('electron');
    electron.ipcRenderer.send('open.devtools');
  }

  download() {
    log('download');
  }

  renderTextMessage(rootMessage: Message, enter = '\n'): string {
    log('renderTextMessage');
    log(rootMessage);
    const render = (message: Message): string => {
      let text = '';
      let name = '';
      if (message.forward_from) {
        name =
          'Переслано от ' +
          ((message.forward_from?.name?.first || '') + ' ' + (message.forward_from?.name?.last || ''));
      } else {
        name = (message?.name?.first || '') + ' ' + (message?.name?.last || '');
      }
      text +=
        name +
        ', [' +
        this.datePipe.transform(message.date, 'short') +
        ']' +
        enter +
        (message.text || '') +
        enter +
        enter;
      return text;
    };
    const renderReply = (messages: Message[]): string => {
      let text = '';
      from(messages)
        .pipe()
        .subscribe((childMessage: Message) => {
          if (childMessage?.text?.length > 0) text += render(childMessage);
          if (childMessage?.reply_to_messages) {
            text += renderReply(childMessage?.reply_to_messages);
          }
        });

      text += render(rootMessage);
      return text;
    };
    let text = '';
    if (rootMessage?.reply_to_messages) {
      text += renderReply(rootMessage?.reply_to_messages);
    } else {
      text += rootMessage?.text || '';
    }
    return text.replace('<br>', enter).split('<br />').join(enter);
  }

  get maxAutoplaySize() {
    // TODO return isMobile() ? 2 * 1024 * 1024 : 4 * 1024 * 1024;
    return 0;
  }

  getSpellCheck(text: string): Observable<any> {
    return this.http.get(`https://speller.yandex.net/services/spellservice.json/checkText?text=${text}`);
  }

  getVarLocal(name: string, defaultValue: any = {}, key: string | boolean = false) {
    try {
      return JSON.parse(localStorage.getItem(name + '_' + (key || this.token))) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  selectTextCancel(): void {
    if (window?.getSelection) {
      if (window.getSelection().empty) {
        // Chrome
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) {
        // Firefox
        window.getSelection().removeAllRanges();
      }
    }
  }

  setVarLocal(name: string, val: any, key: string | boolean = false): void {
    try {
      localStorage.setItem(name + '_' + (key || this.token), JSON.stringify(val));
    }catch (e) {
      console.log('Error setVarLocal', e);
      localStorage.removeItem(name + '_' + (key || this.token));
    }
  }

  saveLocalContacts(): void {
    this.setVarLocal('contacts', this.arContacts);
  }

  permissionsCheck(name: string, Service: IMessengerConnector) {
    if (name == 'can_send_media_messages' && Service.type == 'fellowdesk') {
      return false;
    }
    if (!isUndefined(Service.openChat?.permissions)) {
      return Service.openChat.permissions[name];
    }
    switch (name) {
      case 'can_send_messages':
        if (Service.openChat?.type === 'channel') { return false; }
        break;
    }
    return true;
  }

}
